import React, { Fragment } from "react";
import { Route, BrowserRouter, Switch, Redirect } from "react-router-dom";

import ErrorPage from "./pages/ErrorPage";
import Setting from "./pages/Setting";
import Order from "./pages/Order";

import Auth from "./config/auth";
import OrderPlaced from "./pages/OrderPlaced/OrderPlaced";
import OrderVerify from "./pages/OrderVerify/OrderVerify";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import Notifications from "./pages/Notifications";
import OrderInfo from "./pages/OrderInfo/OrderInfo";
import Auction from "./pages/Auction";
import PlaceBid from "./pages/PlaceBid";
import Bid from "./pages/Bid";
import ProductSaved from "./pages/ProductSaved";
import ProductCart from "./pages/ProductCart";
import ProductCheckout from "./pages/ProductCheckout";
import Product from "./pages/Product";
import ProductCategory from "./pages/ProductCategory";
import Search from "./pages/Search/Search";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import MetaTitle from "./components/Helmet/Helmet";
import MarketOne from "./pages/MarketOne";
import MarketTwo from "./pages/MarketTwo";
import StoreHome from "./pages/StoreHome/StoreHome";

const App = (props) => {
  return (
    <BrowserRouter>
    <MetaTitle />
    <ScrollToTop />
      <Switch>
            {/* <Route exact path="/" component={ThemeOne} /> */}
            <Route exact path="/store" component={MarketOne} />
            <Route exact path="/" component={StoreHome} />
            <Route exact path="/store-two" component={MarketTwo} />
            <Route
              exact
              path="/product/:item"
              component={Product}
            />
            <Route exact path="/cart" component={ProductCart} />
            <PrivateRoute exact path="/checkout" component={ProductCheckout} />
            <PrivateRoute exact path="/setting" component={Setting} />
            <PrivateRoute exact path="/order" component={Order} />
            <PrivateRoute exact path="/order-placed" component={OrderPlaced} />
            <PrivateRoute exact path="/order-verify" component={OrderVerify} />
            <PrivateRoute exact path="/change-password" component={ChangePassword} />
        <PrivateRoute exact path="/notifications" component={Notifications} />
        <PrivateRoute exact path="/order-info/:order" component={OrderInfo} />
        <Route exact path="/auction" component={Auction} />
        <PrivateRoute exact path="/place-bid/:item" component={PlaceBid} />
        <Route exact path="/bid" component={Bid} />
        <Route exact path="/search/:item" component={Search} />
        <PrivateRoute exact path="/product-saved" component={ProductSaved} />
        <Route
          exact
          path="/product-category/:category"
          component={ProductCategory}
        />
         <Route exact path="/reset-password" component={ResetPassword} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="*" component={ErrorPage} />
        
        
      </Switch>
    </BrowserRouter>
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      Auth.isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/",
          }}
        />
      )
    }
  />
);

export default App;
